import React from 'react';

import Header from './Header';

import { generateSpotifyRedirectURL } from '../../services/foundation';

import '../../style/header.css';
import '../../style/authPrompt.css';

const AuthPrompt = ({ header, subHeader }) => {

  return (
    <div>
      <Header header={header} subHeader={subHeader} />
      <a id="auth" className="fr ac" href={generateSpotifyRedirectURL(window.location.origin, localStorage)}>
        <img id="spotify-auth" src={require("../../images/menu-items/spotify.png")} alt="spotify logo"></img>
        <p className="bold">authenticate now</p>
      </a>
    </div>
  )
};

export default AuthPrompt;